import { Link } from 'react-router-dom';
import Underline from '#content/Underline/Underline';
import Logo from '#logos/logo.webp';
import PropTypes from 'prop-types';
import { getNavbarSubpageHref } from './navbarLinks';
import NavbarSearch from '#components/Search/NavbarSearch';

const NavbarElement = ({ page = '', color = '', animate = true, navbarVisible = true }) => {
    const visibleSubpages = Array.isArray(page.subpages)
        ? page.subpages.filter((subpage) => subpage !== '__NONE__')
        : [];
    const hasSubpageDropdown = visibleSubpages.length > 1;

    return (
        <div className={`anikino__navbar-element ${page.name} ${color}`}>
            {page.name == 'skeleton' && <div className="anikino__skeleton"></div>}
            {page.name == 'logo' && (
                <Link to={'/'}>
                    <img src={Logo} alt="Logo" className="anikino__navbar-logo" />
                </Link>
            )}
            {page.name == 'search' && (
                <Underline color={color} show={animate}>
                    <NavbarSearch navbarVisible={navbarVisible} />
                </Underline>
            )}
            {page.name != 'search' && page.name != 'logo' && page.name != 'skeleton' && (
                <Underline color={color} show={animate}>
                    <p className="anikino__navbar-paragraph">
                        {page.pl}
                        {visibleSubpages.length > 0 && (
                            <Link
                                to={getNavbarSubpageHref(page, visibleSubpages[0])}
                                className="anikino__navbar-link"
                            />
                        )}
                    </p>
                    {hasSubpageDropdown && (
                        <div className={`anikino__navbar-flex second`}>
                            {visibleSubpages.map((subpage) => (
                                <div
                                    className={`anikino__navbar-element subpage ${color}`}
                                    key={subpage.name}
                                >
                                    <p className="anikino__navbar-paragraph">{subpage.pl}</p>
                                    <Link to={getNavbarSubpageHref(page, subpage)}></Link>
                                </div>
                            ))}
                        </div>
                    )}
                </Underline>
            )}
        </div>
    );
};

NavbarElement.propTypes = {
    page: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            name: PropTypes.string,
            path: PropTypes.string,
            pl: PropTypes.string,
            subpages: PropTypes.arrayOf(PropTypes.object),
        }),
    ]),
    color: PropTypes.string,
    animate: PropTypes.bool,
    navbarVisible: PropTypes.bool,
};

export default NavbarElement;
